import { render, staticRenderFns } from "./AddShipmentDlg.vue?vue&type=template&id=d47b7d58&"
import script from "./AddShipmentDlg.vue?vue&type=script&lang=js&"
export * from "./AddShipmentDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddShipmentDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports